// extracted by mini-css-extract-plugin
export var fadeInOut = "_3f-3";
export var icon = "_3f-4";
export var savedIndicator = "_3f-2";
export var savingIndicator = "_3f-0";
export var spin = "_3f-1";